import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: inherit;\n  box-sizing: border-box;\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { withOmitProps } from '../helpers/elements';
import { isDefined } from '../helpers/defined';
import { overflowHiddenStyle, overflowStyle } from '../tokens/overflow';
import { userSelectNoneStyle } from '../tokens/user-select';
import { pointerEventsNoneStyle } from '../tokens/pointer-events';
import { backgroundClipStyle } from '../tokens/background';
import { height } from '../style/height';
import { width } from '../style/width';
export var imageContainerMixin = css(_templateObject(), function (_ref) {
  var absolute = _ref.absolute,
      $absolute = _ref.$absolute;
  return (
    /* prettier-ignore */
    absolute || $absolute || !isDefined(absolute != null ? absolute : $absolute) ? "\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    " : "\n      position: relative;\n    "
  );
}, function (_ref2) {
  var _ref3, _ref4;

  var value = _ref2.width,
      imageWidth = _ref2.imageWidth,
      $width = _ref2.$width;
  return isDefined((_ref3 = imageWidth != null ? imageWidth : value) != null ? _ref3 : $width) ? width((_ref4 = imageWidth != null ? imageWidth : value) != null ? _ref4 : $width) : '';
}, function (_ref5) {
  var _ref6, _ref7;

  var value = _ref5.height,
      imageHeight = _ref5.imageHeight,
      $height = _ref5.$height;
  return isDefined((_ref6 = imageHeight != null ? imageHeight : value) != null ? _ref6 : $height) ? height((_ref7 = imageHeight != null ? imageHeight : value) != null ? _ref7 : $height) : '';
}, function (_ref8) {
  var backgroundColor = _ref8.backgroundColor,
      $backgroundColor = _ref8.$backgroundColor;
  return backgroundColor || $backgroundColor ? "background-color: " + (backgroundColor || $backgroundColor) + ";" : '';
});
export var imageContainerKeys = ['absolute', 'imageWidth', 'imageHeight', 'backgroundColor'];
var ImageContainer = styled.div.withConfig(withOmitProps([].concat(imageContainerKeys)))(_templateObject2(), imageContainerMixin, overflowStyle, overflowHiddenStyle, userSelectNoneStyle, pointerEventsNoneStyle, backgroundClipStyle);
export default ImageContainer;